'use client'
import { usePathname } from 'next/navigation'
import React from 'react'

/** Título do cabeçalho das telas de conta e de login, pela rota; as demais rotas mostram a marca. */
const TITLES: Record<string, string> = {
    '/perfil/editar': 'Editar Perfil',
    '/perfil': 'Minha Conta',
    '/perfil/enderecos': 'Meus Endereços',
    '/cadastro': 'Cadastre-se',
    '/login': 'Fazer Login',
    '/checkout': 'Checkout',
}

const DEFAULT_TITLE = 'Glöfi'

const PageTitle: React.FC = () => {
    const pathname = usePathname()
    const pageTitle = TITLES[pathname ?? ''] ?? DEFAULT_TITLE

    return (
        <h1 className="text-white text-[46px] max-md:text-[36px] font-semibold ml-4 md:ml-8 title-head-size ">
            <span className="font-eldwin-script text-[54px] max-md:text-[44px]">{pageTitle}</span>
        </h1>
    )
}

export default PageTitle
